import axios from "@/plugins/axios";

let url = "/api/v1/cash";

export const cash = {
    details: {
        gets(data){
            return axios.get(`${url}/details`, data).then(result => {
                let { cashes } = result.data;
                return {
                    details: cashes?.data,
                    summary: cashes?.summary,
                    ...result.data
                }
            });
        },
    },
    exchange: {
        put(data){
            return axios.put(`${url}/exchange`, data).then(result => result.data);
        },
    }
}